export default __webpack_public_path__ + "static/medium-image-sportplus-1-fcaa6c978c46153acfac3277b6fb14ab.png";